import { memo } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import {
  ListItemIcon,
  ListItemText,
} from "layouts/Flow Designer/components/Titlebar/components/TitlebarActions/StyledComponents";

const ContextHeaderButton = ({ icon, label, action, disabled }) => {
  return (
    <ListItem title={label}>
      <ListItemButton onClick={action} disabled={!!disabled} sx={{ borderRadius: "8px" }}>
        <ListItemIcon>
          {icon}
          <ListItemText primary={label} sx={{ alignItems: "center", display: "flex" }} />
        </ListItemIcon>
      </ListItemButton>
    </ListItem>
  );
};

export default memo(ContextHeaderButton);
